import React from 'react';
import { Route, Switch } from 'react-router-dom';
import './App.css';
import { Layout } from 'antd';
import MenuComponent from "./components/Menu/MenuComponent";
import Overview from "./components/Overview/Overview";
import GetStarted from "./components/Documentation/GetStarted/GetStarted";
import Backend from "./components/Documentation/Backend/Backend";
import Design from "./components/Documentation/Design/Design";
import Table from "./components/Documentation/Table/Table";
import Calendar from "./components/Documentation/Calendar/Calendar";
import List from "./components/Documentation/List/List";
import Management from "./components/Documentation/Management/Management";
import Forms from "./components/Documentation/Forms/Forms";
import Taskpage from "./components/Documentation/Taskpage/Taskpage";
import Preferences from "./components/Documentation/Preferences/Preferences";
import Dark from "./components/Documentation/Dark/Dark";
import Libraries from "./components/Libraries/Libraries";
import Authors from "./components/Authors/Authors";

const { Footer, Content, Header } = Layout;

const App = () => {
  return (
      <>
          <Layout>
              <MenuComponent/>
              <Layout>
                  <Header className="site-layout-sub-header-background" style={{ padding: 0, height: 90 }}>
                      <div className="app-header"><span style={{paddingRight: 30}}>Schedule - расписание курса RS School by team 46</span>
                      </div>
                  </Header>
                  <Content style={{ margin: '0px 16px 0' }}>
                      <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
                          <Content>
                              <Switch>
                                  <Route exact path="/">
                                      <Overview />
                                  </Route>
                                  <Route path="/docs/start">
                                      <GetStarted />
                                  </Route>
                                  <Route path="/docs/backend">
                                      <Backend />
                                  </Route>
                                  <Route path="/docs/design">
                                      <Design />
                                  </Route>
                                  <Route path="/docs/components/table">
                                      <Table />
                                  </Route>
                                  <Route path="/docs/components/calendar">
                                      <Calendar />
                                  </Route>
                                  <Route path="/docs/components/list">
                                      <List />
                                  </Route>
                                  <Route path="/docs/components/management">
                                      <Management />
                                  </Route>
                                  <Route path="/docs/components/forms">
                                      <Forms />
                                  </Route>
                                  <Route path="/docs/components/taskpage">
                                      <Taskpage />
                                  </Route>
                                  <Route path="/docs/features/preferences">
                                      <Preferences />
                                  </Route>
                                  <Route path="/docs/features/dark">
                                      <Dark />
                                  </Route>
                                  <Route path="/libraries">
                                      <Libraries />
                                  </Route>
                                  <Route path="/authors">
                                      <Authors />
                                  </Route>
                              </Switch>
                          </Content>
                      </div>
                  </Content>
              </Layout>
          </Layout>
      </>
      )
};

export default App;
